import TakeTrialLesson from './TakeTrialLesson';

export default TakeTrialLesson;
